export const devices = {
  apple: [
    'ipad-air-space-gray-landscape.png',
    'ipad-air-space-gray-portrait.png',
    'ipad-mini-starlight-landscape.png',
    'ipad-mini-starlight-portrait.png',
    'ipad-pro-11-space-gray-landscape.png',
    'ipad-pro-11-space-gray-portrait.png',
    'ipad-pro-12-9-space-gray-landscape.png',
    'ipad-pro-12-9-space-gray-portrait.png',
    'ipad-silver-landscape.png',
    'ipad-silver-portrait.png',
    'iphone-11-portrait.png',
    'iphone-11-pro-max-portrait.png',
    'iphone-11-pro-portrait.png',
    'iphone-12-mini-white-portrait.png',
    'iphone-12-pro-max-silver-portrait.png',
    'iphone-12-pro-silver-landscape.png',
    'iphone-12-pro-silver-portrait.png',
    'iphone-12-white-portrait.png',
    'iphone-13-midnight.png',
    'iphone-13-mini-midnight.png',
    'iphone-13-mini-starlight.png',
    'iphone-13-pro-graphite-landscape.png',
    'iphone-13-pro-graphite-portrait.png',
    'iphone-13-pro-max-graphite-portrait.png',
    'iphone-13-pro-max-silver-portrait.png',
    'iphone-13-pro-silver-landscape.png',
    'iphone-13-pro-silver-portrait.png',
    'iphone-13-starlight.png',
    'iphone-14-blue-landscape.png',
    'iphone-14-blue-portrait.png',
    'iphone-14-midnight-landscape.png',
    'iphone-14-midnight-portrait.png',
    'iphone-14-plus-blue-landscape.png',
    'iphone-14-plus-blue-portrait.png',
    'iphone-14-plus-midnight-landscape.png',
    'iphone-14-plus-midnight-portrait.png',
    'iphone-14-plus-purple-landscape.png',
    'iphone-14-plus-purple-portrait.png',
    'iphone-14-plus-red-landscape.png',
    'iphone-14-plus-red-portrait.png',
    'iphone-14-plus-starlight-landscape.png',
    'iphone-14-plus-starlight-portrait.png',
    'iphone-14-pro-deep-purple-landscape.png',
    'iphone-14-pro-deep-purple-portrait.png',
    'iphone-14-pro-gold-landscape.png',
    'iphone-14-pro-gold-portrait.png',
    'iphone-14-pro-max-deep-purple-landscape.png',
    'iphone-14-pro-max-deep-purple-portrait.png',
    'iphone-14-pro-max-gold-landscape.png',
    'iphone-14-pro-max-gold-portrait.png',
    'iphone-14-pro-max-silver-landscape.png',
    'iphone-14-pro-max-silver-portrait.png',
    'iphone-14-pro-max-space-black-landscape.png',
    'iphone-14-pro-max-space-black-portrait.png',
    'iphone-14-pro-silver-landscape.png',
    'iphone-14-pro-silver-portrait.png',
    'iphone-14-pro-space-black-landscape.png',
    'iphone-14-pro-space-black-portrait.png',
    'iphone-14-purple-landscape.png',
    'iphone-14-purple-portrait.png',
    'iphone-14-red-landscape.png',
    'iphone-14-red-portrait.png',
    'iphone-14-starlight-landscape.png',
    'iphone-14-starlight-portrait.png',
    'iphone-15-black-landscape.png',
    'iphone-15-black-portrait.png',
    'iphone-15-blue-landscape.png',
    'iphone-15-blue-portrait.png',
    'iphone-15-green-landscape.png',
    'iphone-15-green-portrait.png',
    'iphone-15-pink-landscape.png',
    'iphone-15-pink-portrait.png',
    'iphone-15-plus-black-landscape.png',
    'iphone-15-plus-black-portrait.png',
    'iphone-15-plus-blue-landscape.png',
    'iphone-15-plus-blue-portrait.png',
    'iphone-15-plus-green-landscape.png',
    'iphone-15-plus-green-portrait.png',
    'iphone-15-plus-pink-landscape.png',
    'iphone-15-plus-pink-portrait.png',
    'iphone-15-plus-yellow-landscape.png',
    'iphone-15-plus-yellow-portrait.png',
    'iphone-15-pro-black-titanium-landscape.png',
    'iphone-15-pro-black-titanium-portrait.png',
    'iphone-15-pro-blue-titanium-landscape.png',
    'iphone-15-pro-blue-titanium-portrait.png',
    'iphone-15-pro-max-black-titanium-landscape.png',
    'iphone-15-pro-max-black-titanium-portrait.png',
    'iphone-15-pro-max-blue-titanium-landscape.png',
    'iphone-15-pro-max-blue-titanium-portrait.png',
    'iphone-15-pro-max-natural-titanium-landscape.png',
    'iphone-15-pro-max-natural-titanium-portrait.png',
    'iphone-15-pro-max-white-titanium-landscape.png',
    'iphone-15-pro-max-white-titanium-portrait.png',
    'iphone-15-pro-natural-titanium-landscape.png',
    'iphone-15-pro-natural-titanium-portrait.png',
    'iphone-15-pro-white-titanium-landscape.png',
    'iphone-15-pro-white-titanium-portrait.png',
    'iphone-15-yellow-landscape.png',
    'iphone-15-yellow-portrait.png',
  ],
};
